import { z } from "zod";

export function zPathParamIntId<A extends z.ZodTypeAny, B extends PropertyKey>(
  branded: z.ZodBranded<A, B>,
) {
  return z.string().transform((x) => branded.parse(Number(x)));
}
